// Расширения `.js` обязательны: их сохраняет ESM-сборка, и без них полученный
// модуль невалиден для Node как ESM. TypeScript сопоставляет такой путь
// с исходным `.ts`, а CommonJS-сборка резолвит его как обычный файл.
// Первым: настройка разбора должна встать раньше, чем создадутся схемы,
// а создаются они на загрузке модулей ниже. Почему — в самом модуле.
import './jit.js';
import { installMessageKeys } from './messages.js';
export * from './messages.js';
export * from './errors.js';
export * from './health.js';
export * from './pagination.js';
export * from './permissions.js';
export * from './auth.js';
export * from './organizations.js';
export * from './users.js';
export * from './sites.js';
export * from './audit.js';
export * from './agents.js';
export * from './tunnel.js';
export * from './addresses.js';
export * from './nodes.js';
export * from './monitors.js';
export * from './telemetry.js';
export * from './internal.js';
export * from './credentials.js';
export * from './vnc.js';
export * from './ssh.js';
export * from './sessions.js';
export * from './files.js';
export * from './cameras.js';
export * from './archive.js';
export * from './recorders.js';
export * from './layouts.js';
export * from './overview.js';
export * from './notifications.js';
export * from './discovery.js';
export * from './agent-update.js';
/*
  Машинные ключи в сообщениях проверок включаются один раз на процесс:
  настройка Zod глобальная, и оставлять её на совести каждого приложения
  значило бы однажды получить сервер с ключами, а клиент — с английскими
  фразами библиотеки.
*/
installMessageKeys();
//# sourceMappingURL=index.js.map